import React from 'react';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {useExpiringSection} from './ExpiringSection.hook';
interface ExpiringSectionProps {
  expiringCreditsCountFrontline: number | null;
  expiringRewardsCountFrontlineOrg: number | null;
  onShowInfoPopover: () => void;
  onShowReport: () => void;
  screenName: string;
}

export const ExpiringSection = ({
  expiringCreditsCountFrontline = null,
  expiringRewardsCountFrontlineOrg = null,
  onShowInfoPopover = () => {},
  onShowReport = () => {},
}: ExpiringSectionProps) => {
  const {listItems, onInfoPress, onItemPress, tt, ts} = useExpiringSection({
    expiringCreditsCountFrontline,
    expiringRewardsCountFrontlineOrg,
    onShowInfoPopover,
    onShowReport,
  });

  return (
    <MetricSection
      analyticsTitle="Expiring In The Next 14 Days."
      testID={MetricsSection.metricSectionExpiring}
      title={tt('heading', 'Expiring In The Next 14 Days')}
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Expiring Section Information button',
      )}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
    />
  );
};

export default ExpiringSection;
